import type { Constructable } from 'bz-utilities/ts';

import { decorate, observable } from 'mobx';

export type TKeyObj<T> = Record<keyof T, boolean>;

export const MobxAutoDecorate = <T extends object, K extends keyof T = keyof T>(
  Clazz: new (...args: any[]) => T,
  ...keys: K[]
) => {
  decorate(
    Clazz,
    Object.fromEntries(
      keys.map((K) => {
        return [K, observable];
      })
    )
  );
};

export const MobxAutoDecorateWithKeyObj = <T extends object, K extends keyof T = keyof T>(
  Clazz: Constructable<T>,
  keyObject: TKeyObj<T>
) => {
  const keys = Object.entries(keyObject).reduce((acc, [key, val]) => {
    return acc.addIf(val as boolean, key as K);
  }, [] as K[]);
  MobxAutoDecorate(Clazz, ...keys);
};
